// Search facets replace their section without reloading the document head.
// Keep document/share titles aligned with the server-rendered visible result count.
(() => {
  const syncTitle = () => {
    const title = document.querySelector('[data-senschef-search-title]')?.getAttribute('data-senschef-search-title');
    if (!title) return;
    if (document.title !== title) document.title = title;
    for (const selector of ['meta[property="og:title"]', 'meta[name="twitter:title"]']) {
      const meta = document.querySelector(selector);
      if (meta) meta.content = title;
    }
  };
  const main = document.getElementById('main');
  if (!main) return;
  syncTitle();
  new MutationObserver(syncTitle).observe(main, { childList: true, subtree: true });
  window.addEventListener('pageshow', syncTitle);
})();
